function editUserDataFieldsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/edit-user-data-fields/edit-user-data-fields.html?$$REVISION$$'
  }
}

export { editUserDataFieldsDialog }
